import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {RequesterService} from "../shared/services/requester/requester.service";
import {DbResponse} from "../shared/interceptors/db-response";
import {DbStoreState} from '../store/reducers';
import {Store} from '@ngrx/store';
import * as fromStore from '../store';
import {AuthService} from "../auth/auth.service";
import {GlobalEventDispatcherService} from "../shared/services/global-event-dispatcher/global-event-dispatcher.service";
import {Router} from "@angular/router";
import {map} from "rxjs/operators";


@Injectable()
export class UserManagementService {
  private currentWorkspaceId: any;
  private ownerWorkspaceId: any;

  constructor(
    private _requester: RequesterService,
    private _store: Store<DbStoreState>,
    private _authService: AuthService,
    private _globalEventDispatcherService: GlobalEventDispatcherService,
    private _router: Router,

  ) {
    this._store.select(fromStore.getWorkspaceIdEntities).subscribe( workspaceIdEntities => {
      this.ownerWorkspaceId = workspaceIdEntities.ownerWorkspaceId;
      this.currentWorkspaceId = workspaceIdEntities.currentWorkspaceId || this.ownerWorkspaceId;
    });
  }

  public getWorkspaceClients(): BehaviorSubject<DbResponse> {
    return <BehaviorSubject<DbResponse>>(this._requester.auth
      .get(`workspaces/${this.ownerWorkspaceId}/clients`, null, true)
      .pipe(map((response: DbResponse): any => {
        /*TODO HOVO mapper*/
        if (response && response.success) {
          return response;
        }
      })));
  }
  public removeInvitation(workspaceInvitationId: number, password: any): BehaviorSubject<DbResponse> {

    const passwordData = {
      password: password
    };
    return this._requester.auth
      .delete(`workspaces/${this.currentWorkspaceId}/invitation/${workspaceInvitationId}/remove`, null, passwordData);
  }

  public acceptInvitation(workspaceInvitationId: number): BehaviorSubject<DbResponse> {

    return this._requester.auth
      .post(`workspaces/${this.ownerWorkspaceId}/invitation/${workspaceInvitationId}/accept`, null, null);
  }

  public resendInvitation(workspaceInvitationId: number): BehaviorSubject<DbResponse> {
    return this._requester.core
      .post(`workspaces/${this.ownerWorkspaceId}/invitation/${workspaceInvitationId}/re-invite`, null, null);
  }

  public removeUser(clientId: number, password: any) {
    const passwordData = {
      password: password
    };
    return this._requester.auth
      .delete(`workspaces/${this.currentWorkspaceId}/clients/${clientId}/remove`, null, passwordData);
  }

  public leaveWorkspace(workspaceId: number, password: any) {
    const passwordData = {
      password: password
    };
    return this._requester.core
      .delete(`workspaces/${workspaceId}/leave`, null, passwordData);
  }
  public inviteUser(data) {
    return this._requester.core
      .post(`workspaces/${this.ownerWorkspaceId}/invite`, null, data);
  }

  public updateUser(data) {
    return this._requester.auth
      .patch(`workspaces/${this.ownerWorkspaceId}/role`, null, data);
  }

  public switchWorkspace(workspaceId, setLocalStorage = true) {
/*    if (!!localStorage.getItem('dbSwitchWorkspace')) {
      return null;
    }
    if (setLocalStorage) {
      localStorage.setItem('dbSwitchWorkspace',  'true');
    }*/
    localStorage.removeItem('dbFirebaseToken');
    return this._requester.core
      .post(`workspaces/${workspaceId}/switch`)
      .pipe(map((response: DbResponse) => {
        if (response && response.success) {
          setTimeout(() => {
            localStorage.removeItem('dbSwitchWorkspace');
          }, 2000);
          this._router.navigate(['/websites']);
          this._store.dispatch(new fromStore.SetWorkspaceIdEntities({
              ownerWorkspaceId: response.data.owned_workspace_id,
              currentWorkspaceId: response.data.current_workspace_id,
              currentWorkspaceRoleId: response.data.role_id,
              globalEventDispatcherService: this._globalEventDispatcherService
            }));
          this._store.dispatch(new fromStore.LoadUser());
          this._store.dispatch(new fromStore.LoadUserSubscription());
          this._store.dispatch(new fromStore.LoadUserAvailableSubscriptions());
          this._store.dispatch(new fromStore.LoadUserLocalStorage());
          this._store.dispatch(new fromStore.LoadUserPaymentMethods());
          this._store.dispatch(new fromStore.ClearWebsites());
          this._store.dispatch(new fromStore.LoadWebsites());
          this._store.dispatch(new fromStore.SwitchWorkspace({switching: false, workspaceName: '', redirect: true}));
        }

        return response;
      }));
  }

  public updateWorkspaceData(data) {
    return this._requester.auth
      .patch(`workspaces/${this.ownerWorkspaceId}/edit`, null, data);
  }
}
